import type {
  Ref,
  ComponentPropsWithoutRef,
} from "react"

import {
  useCallback,
  forwardRef,
} from "react"

import styles from "./Dialog.module.scss"
import { useDialogContext } from "./useDialogContext"
import { CloseIcon } from "src/icons"

type Props = ComponentPropsWithoutRef<"button">

export const DialogCloseX = forwardRef<HTMLButtonElement, Props>(
  function DialogCloseX(props: Props, propRef: Ref<HTMLButtonElement>) {
    const { setOpen } = useDialogContext()

    const closeDialog = useCallback(
      () => {
        setOpen(false)
      },
      [setOpen],
    )

    return (
      <button
        {...props}
        type="button"
        ref={propRef}
        onClick={closeDialog}
        className={styles.dialogCloseButton}
      >
        <CloseIcon className={styles.dialogCloseIcon} />
      </button>
    )
  },
)
